import React from 'react';
import { Col, FormGroup, Label, Input, Row } from 'reactstrap';
import { H5, Image } from 'AbstractElements';
import { useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import PostCommon from 'Component/Common/Form/Post';
import DropzoneCommon from 'Component/Common/Upload/Dropzone';
import { submitCategory } from 'Services/Features/Category/Utils/categoryUtils';
import { setFormData, resetFormData } from 'Services/Features/Category/categorySlice';
import CustomLoader from 'Component/Common/CustomLoader';

const CategoryForm = ({ label, setRefetch }) => {
    const dispatch = useDispatch();
    const history = useNavigate();
    const data = useSelector(state => state.category.currentCategory)
    console.log (data, 'data');
    const startUpload = useSelector(state => state.category.loading);

    const handleSuccess = () => {
        dispatch(resetFormData());
        history(`${process.env.PUBLIC_URL}/treatment-category`);
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        console.log(data, 'data');
        dispatch(submitCategory({ ...data, successCallback: handleSuccess }))
    };

    const handleDiscard = (e) => {
        e.preventDefault();
        dispatch(resetFormData());
        history(`${process.env.PUBLIC_URL}/treatment-category`);
    };
    const handleChanges = (e) => {
        const { name, value } = e.target;
        dispatch(setFormData({ [name]: value }));
    }

    const handleChangeBanner = ({ meta, file }, status) => {
        if (status === 'done') {
            dispatch(setFormData({ 'banner': file }));
        } else if (status === 'removed') {
            dispatch(setFormData({ 'banner': null }));
        }
    };


    return (
        <PostCommon title={label} handleSubmit={handleSubmit} handleDiscard={handleDiscard} >
            {startUpload && (
                <CustomLoader />
            )}
            <div>
                <Row className="mb-3">
                    <Col sm={data.bannerLink ? 12 : 6}>
                        <FormGroup className='mb-3'>
                            <Label for="validationName" style={{ fontWeight: 'bold' }}>Nama :</Label>
                            <Input
                                className="form-control"
                                id="validationName"
                                type="text"
                                name="name"
                                placeholder="Masukkan nama kategori perawatan..."
                                required=""
                                value={data.name}
                                onChange={handleChanges}
                            />
                        </FormGroup>
                        <FormGroup className='mb-3'>
                            <Label for="validationAbout" style={{ fontWeight: 'bold' }}>Tentang Kategori :</Label>
                            <Input
                                className="form-control"
                                id="validationAbout"
                                type="text"
                                name="about"
                                placeholder="Masukkan ringkasan tentang kategori perawatan..."
                                required=""
                                value={data.about}
                                onChange={handleChanges}
                            />
                        </FormGroup>
                        <FormGroup className='mb-3'>
                            <Label for="validationDescription" style={{ fontWeight: 'bold' }}>Deskripsi Lengkap :</Label>
                            <Input
                                className="form-control"
                                id="validationDescription"
                                type="textarea"
                                name="description"
                                placeholder="Masukkan deskripsi lengkap tentang kategori perawatan..."
                                required=""
                                value={data.description}
                                style={{ height: '150px' }}
                                onChange={handleChanges}
                            />
                        </FormGroup>
                    </Col>

                    {data.bannerLink ? (
                        <>
                            <Col sm="4">
                                <H5>Preview Banner Kategori Perawatan</H5>
                                <Image
                                    attrImage={{
                                        className: 'img-fluid w-100',
                                        src: data.bannerLink,
                                        alt: `${data.name}`,
                                        style: {
                                            height: 'auto',
                                            width: '100%',
                                            maxWidth: '600px',
                                            objectFit: 'contain',
                                            borderRadius: '8px'
                                        }
                                    }}
                                />
                            </Col>
                            <Col sm="8">
                                <DropzoneCommon
                                    label={'Banner Kategori'}
                                    inputContent={'Update banner kategori'}
                                    handleChangeStatus={handleChangeBanner}
                                    accept="image/*"
                                    multiple={false}
                                    maxFiles={1}
                                />
                            </Col>
                        </>
                    ) : (
                        <Col sm="6">
                            <DropzoneCommon
                                label={'Banner Kategori'}
                                inputContent={'Silahkan upload banner kategori'}
                                handleChangeStatus={handleChangeBanner}
                                accept="image/*"
                                multiple={false}
                                maxFiles={1}
                            />
                        </Col>
                    )}
                </Row>
            </div>
        </PostCommon>
    );
};

export default CategoryForm;